<notifier-container></notifier-container>
<div class="fileUploadContainer">
    <div class="header hdr">
        <h5><span class="animateH5">File Upload</span></h5>
    </div>
    <div class="col-md-12" *ngIf="!showComponent">
        <div class="text-center headingRow hdr2">
            <!-- <h2>Upload your files by choosing any one of the options below</h2> -->
             <h2>Upload your files</h2>
        </div>
        <div class="text-center justify-content-center contentRow form-group">

            <li class="file jerk-class" (click)="filesFormat('audio')" 
                (click)="fileUpload.click()" tooltip="Upload Only .wav, .mp3, .flac files" [options]="myOptions">
                <i class="fa fa-headset iconsFile"></i>
                <input type="file" #fileUpload class="form-control" accept=".wav, .mp3, .flac"
                    (change)="onFileChange($event,['wav','mp3','flac'])" multiple="multiple">
                <p class="fileText">Upload Voice Mail Calls</p>
            </li>
            <!-- <li class="file jerk-class" (click)="filesFormat('pdf')" 
                (click)="fileUpload2.click()" tooltip="Upload Only .pdf, .txt, .docx files" [options]="myOptions">
                <i class="fa fa-file-pdf iconsFile"></i>
                <input type="file" #fileUpload2 class="form-control" accept=".pdf, .txt, .docx"
                    (change)="onFileChange($event,['pdf','txt','docx'])" multiple="multiple">
                <p class="fileText">Upload PDF & Text</p>
            </li>
            <li class="file jerk-class" (click)="filesFormat('email')" 
                (click)="fileUpload3.click()" tooltip="Upload Only .pdf, .txt, .docx files" [options]="myOptions">
                <i class="fa-regular fa-envelope iconsFile"></i>
                <input type="file" #fileUpload3 class="form-control" accept=".pdf, .txt, .docx"
                    (change)="onFileChange($event,['pdf','txt','docx'])" multiple="multiple">
                <p class="fileText">Upload Email Text</p>
            </li> -->
            <!-- @if(clientcodeId=='5f434c0d93bd2600072a87e4'){ 
            <li class="file jerk-class"  
                (click)="fileUpload5.click()" tooltip="Upload Only .csv files" [options]="myOptions">
                <i class="fa fa-file-excel iconsFile"></i>
                <input type="file" #fileUpload5 class="form-control" accept=".csv"
                    (change)="chooseUploadSurveyFeedback($event,['csv'])">
                <p class="fileText">Upload Feedback</p>
            </li>
            }  -->
            <!-- <li class="file jerk-class"  
                (click)="fileUpload4.click()" tooltip="Upload Only .pdf, .docx files" [options]="myOptions">
                <i class="fa fa-file-pdf iconsFile"></i>
                <input type="file" #fileUpload4 class="form-control" accept=".pdf,.docx"
                    (change)="chooseUploadFilellm($event)">
                <p class="fileText">Train Model</p>
            </li> -->
        </div>
    </div>
    <div class="container-fluid fileUploadSecondPart" *ngIf="showComponent">
        <div class="row file-upload-main-column">
            <div class="col-md-3 offset-md-1 file-column">
                <div class="container-fluid">
                    <p class="listHead text-center">Choose files for upload</p>
                    <ul class="list-group list-group-horizontal" *ngFor="let file of fileData; index as j">
                        <li class="list-group-item listFirst"><i class="fa-solid fa-microphone upload-format-icons"
                                *ngIf="selectFile == 'audio' "></i> <i
                                class="fa-regular fa-file-lines upload-format-icons"
                                *ngIf="file?.type == 'text/plain' "></i><i *ngIf="file?.type == 'application/pdf' "
                                class="fa-solid fa-file-pdf upload-format-icons"></i>
                            <i class="fa-regular fa-file upload-format-icons"
                                *ngIf="file?.type == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'"></i>
                        </li>


                        <li class="list-group-item listCenter">{{file?.name}}
                            <p>{{file?.size % 1000}} KB</p>
                        </li>
                        <li class="list-group-item listLast">
                            <i class="fa-regular fa-trash-can deleteIcon" data-bs-toggle="modal"
                                data-bs-target="#exampleModal" tooltip="Delete File" [options]="myOptions"
                                (click)="justShowIndex(j)"></i>
                        </li>
                    </ul>
                    <div class="form-group text-center addMore">
                        <div class="form-group" *ngIf="selectFile == 'audio'">
                            <input (change)="onFileChange($event,['wav','mp3','flac'])" #fileUpload type="file"
                                class="form-control choose-input" accept=".wav, .mp3, .flac " size="40"
                                multiple="multiple">
                            <button class="btn btn-primary updateBtn" (click)="fileUpload.click()">Add More</button>
                            <span class="text-danger" *ngIf="fileData.length === 0">No file chosen.</span>
                        </div>
                        <div class="form-group" *ngIf="selectFile == 'pdf'">
                            <input (change)="onFileChange($event,['pdf','txt','docx'])" #fileUpload2 type="file"
                                class="form-control choose-input" accept=".pdf, .txt, .docx" size="40"
                                multiple="multiple">
                            <button class="btn btn-primary signInBtn" (click)="fileUpload2.click()">Add More</button>
                            <span class="text-danger" *ngIf="fileData.length === 0">No file chosen.</span>
                        </div>
                        <div class="form-group" *ngIf="selectFile == 'email'">
                            <input (change)="onFileChange($event,['pdf','txt','docx'])" #fileUpload3 type="file"
                                class="form-control choose-input" accept=".pdf, .txt, .docx" size="40"
                                multiple="multiple">
                            <button class="btn btn-primary signInBtn" (click)="fileUpload3.click()">Add More</button>
                            <span class="text-danger" *ngIf="fileData.length === 0">No file chosen.</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-3 offset-md-1 form-column">
                <form [formGroup]="uploadForm">
                    <div class="form-group">
                        <label for="" class="form-label mandatoryLabel">Display Name <i
                                class="fa-solid fa-asterisk mandatoryIcon"></i></label>
                        <input formControlName="displayName" type="text" class="form-control"
                            placeholder="Enter the queue name">
                        <span class="text-danger"
                            *ngIf="uploadForm.controls['displayName'].invalid && uploadForm.controls['displayName'].dirty && uploadForm.hasError('required','displayName')">
                            Display name is required</span>
                            <span class="text-danger"
                            *ngIf="uploadForm.controls['displayName'].value !='' && uploadForm.hasError('pattern','displayName')">
                            Enter valid display name</span>
                    </div>
                    <div class="form-group" *ngIf="selectFile == 'email'">
                        <label for="" class="form-label mandatoryLabel">From Email <i
                                class="fa-solid fa-asterisk mandatoryIcon"></i></label>
                        <input formControlName="emailfrom" type="email" class="form-control"
                            placeholder="Enter the Email from">
                        <span class="text-danger"
                            *ngIf="uploadForm.controls['emailfrom'].invalid && uploadForm.controls['emailfrom'].dirty && uploadForm.hasError('required','emailfrom')">
                            From email is required</span>
                            <span class="text-danger"
                            *ngIf="uploadForm.controls['emailfrom'].value !='' && uploadForm.hasError('pattern','emailfrom')">
                            Enter valid email</span>
                    </div>
                    <div class="form-group" *ngIf="selectFile == 'email'">
                        <label for="" class="form-label">To Email</label>
                        <tag-input formControlName="emailto" class="form-control tagInput-form-control"
                            placeholder="To Email" secondaryPlaceholder="Enter To Email" [trimTags]="true"
                            [addOnBlur]="true" [clearOnBlur]="true" [modelAsStrings]="true" theme="minimal" id="emailto"
                            name="emailto" autocomplete="off" [addOnPaste]="true"
                            [pasteSplitPattern]="splitPattern" (onAdd)="onItemAdded($event,'emailto')"></tag-input>
                    </div>
                    <div class="form-group" *ngIf="selectFile == 'email'">
                        <label for="" class="form-label">CC Email</label>
                        <tag-input formControlName="cc" class="form-control tagInput-form-control"
                            placeholder="CC Email" secondaryPlaceholder="Enter CC Email" [trimTags]="true"
                            [addOnBlur]="true" [clearOnBlur]="true" [modelAsStrings]="true" theme="minimal" id="cc"
                            name="cc" autocomplete="off" [addOnPaste]="true"
                            [pasteSplitPattern]="splitPattern" (onAdd)="onItemAdded($event,'cc')"></tag-input>
                    </div>
                    <div class="form-group" *ngIf="selectFile == 'email'">
                        <label for="" class="form-label">BCC Email</label>
                        <tag-input formControlName="bcc" class="form-control tagInput-form-control"
                            placeholder="BCC Email" secondaryPlaceholder="Enter BCC Email" [trimTags]="true"
                            [addOnBlur]="true" [clearOnBlur]="true" [modelAsStrings]="true" theme="minimal" id="bcc"
                            name="bcc" autocomplete="off" [addOnPaste]="true"
                            [pasteSplitPattern]="splitPattern" (onAdd)="onItemAdded($event,'bcc')"></tag-input>
                    </div>
                    <div class="form-group" *ngIf="selectFile == 'email'">
                        <label for="" class="form-label">Email Subject</label>
                        <input formControlName="emailsubject" type="text" class="form-control"
                            placeholder="Enter email subject">
                              <span class="text-danger"
                            *ngIf="uploadForm.controls['emailsubject'].value !=='' && uploadForm.hasError('pattern','emailsubject')">
                            Enter subject not valid</span>
                    </div>
                    <div class="form-group" *ngIf="selectFile == 'email'">
                        <label for="" class="form-label">Email Date</label>
                        <!-- <input formControlName="emaildate" type="text" class="form-control"
                            placeholder="Enter the customer name"> -->
                        <input type="text" formControlName="emaildate" class="form-control" ngxDaterangepickerMd
                            [autoApply]="true" [singleDatePicker]="true" (change)="getDateSearchData($event)"
                            [showDropdowns]="true" placeholder="Select email date" [readonly]="true" />
                    </div>
                    <div class="form-check form-check-repeat-email" *ngIf="selectFile == 'email'">
                        <input class="form-check-input" formControlName="isrepeat" type="checkbox"
                            id="flexCheckDefault">
                        <label class="form-check-label" for="flexCheckDefault">
                            <span class="text">Repeat Email</span>
                        </label>
                    </div>
                    <div class="form-group" *ngIf="selectFile == 'audio'">
                        <label for="" class="form-label mandatoryLabel">Customer Name <i
                                class="fa-solid fa-asterisk mandatoryIcon"></i></label>
                        <input formControlName="customerName" type="text" class="form-control"
                            placeholder="Enter the customer name">
                        <span class="text-danger"
                            *ngIf="uploadForm.controls['customerName'].invalid && uploadForm.controls['customerName'].dirty && uploadForm.hasError('required','customerName')">
                            Customer name is required</span>
                            <span class="text-danger"
                            *ngIf="uploadForm.controls['customerName'].value !=='' && uploadForm.hasError('pattern','customerName')">
                            Customer name is required</span>
                    </div>
                    <div class="form-group" *ngIf="selectFile == 'audio'">
                        <label for="" class="form-label mandatoryLabel">Agent Name <i
                                class="fa-solid fa-asterisk mandatoryIcon"></i></label>
                        <input name="agentName" readonly="true" formControlName="agentName" type="text"
                            class="form-control agentFormControl" placeholder="{{userDetails?.name}}" value="{{userDetails?.name}}">
                        <span class="text-danger"
                            *ngIf="uploadForm.controls['agentName'].invalid && uploadForm.controls['agentName'].dirty && uploadForm.hasError('required','agentName')">
                            Agent name is required</span>
                    </div>
                    <div class="form-group">
                        <label for="" class="form-label mandatoryLabel">Topics <i
                                class="fa-solid fa-asterisk mandatoryIcon"></i></label>
                        <ng-select formControlName="topicName" dropdownPosition="auto" name="topicName" id="topicName"
                            (change)="chooseTopic()" placeholder="Choose/Search topic" [clearable]="false">
                            <ng-option [value]="tV.id.$oid" title="{{tV.topic}}"
                                *ngFor="let tV of topicsFileData; index as j">{{tV.topic}}</ng-option>
                        </ng-select>
                        <span class="text-danger"
                            *ngIf="uploadForm.controls['topicName'].invalid && uploadForm.controls['topicName'].dirty && uploadForm.hasError('required','topicName')">
                            Please choose any one topic</span>
                    </div>
                    <!-- <div class="form-group">
                        <label class="form-label" for="disabledTextInput">Keywords / Phrase</label>
                        <tag-input formControlName="keywords" class="form-control tagInput-form-control"
                            placeholder="Keyword" secondaryPlaceholder="Enter Your Keyword" [trimTags]="true"
                            [addOnBlur]="true" [clearOnBlur]="true" [modelAsStrings]="true" theme="minimal"
                            id="keywords" name="keywords" autocomplete="off" [disable]="disableInput"
                            [addOnPaste]="true" [pasteSplitPattern]="splitPattern" (onAdd)="onKeywordsAdded($event,'keywords')"></tag-input>
                        <span class="modalNote">Note: To add multiple keywords, please Press Enter Key after typing
                            each keyword</span>
                    </div>
                    <div class="form-group">
                        <label class="form-label" for="disabledTextInput">Alert Keywords</label>
                        <tag-input formControlName="alertKeywords" class="form-control tagInput-form-control"
                            placeholder="Keyword" secondaryPlaceholder="Enter Your Alert Keyword" [trimTags]="true"
                            [addOnBlur]="true" [clearOnBlur]="true" [modelAsStrings]="true" theme="minimal"
                            id="alertKeywords" name="alertKeywords" autocomplete="off" [disable]="disableInput"
                            [addOnPaste]="true" [pasteSplitPattern]="splitPattern" (onAdd)="onKeywordsAdded($event,'alertKeywords')"></tag-input>
                        <span class="modalNote">Note: To add multiple keywords, please Press Enter Key after typing
                            each keyword</span>
                    </div>
                    <div class="form-group">
                        <label class="form-label" for="disabledTextInput">Sensitive Keywords</label>
                        <tag-input formControlName="sensitiveKeywords" class="form-control tagInput-form-control"
                            placeholder="Keyword" secondaryPlaceholder="Enter Your Sensitive Keyword" [addOnBlur]="true"
                            [clearOnBlur]="true" [modelAsStrings]="true" theme="minimal" id="sensitiveKeywords"
                            name="sensitiveKeywords" autocomplete="off" [disable]="disableInput" [addOnPaste]="true"
                            [pasteSplitPattern]="splitPattern" (onAdd)="onKeywordsAdded($event,'sensitiveKeywords')"></tag-input>
                        <span class="modalNote">Note: To add multiple keywords, please Press Enter Key after typing
                            each keyword</span>
                    </div>
                    <div class="form-group">
                        <label class="form-label">Hide Keywords</label>
                        <tag-input formControlName="hideKeywords" class="form-control tagInput-form-control"
                            placeholder="Keyword" secondaryPlaceholder="Enter Your Hide Keyword" [addOnBlur]="true"
                            [clearOnBlur]="true" [modelAsStrings]="true" theme="minimal" id="hideKeywords"
                            name="hideKeywords" autocomplete="off" [disable]="disableInput" [addOnPaste]="true"
                            [pasteSplitPattern]="splitPattern" (onAdd)="onKeywordsAdded($event,'hideKeywords')"></tag-input>
                        <span class="modalNote">Note: To add multiple keywords, please Press Enter Key after typing
                            each keyword</span>
                    </div>
                    <div class="form-group">
                        <label class="form-label">Delete Keywords</label>
                        <tag-input formControlName="deleteKeywords" class="form-control tagInput-form-control"
                            placeholder="Keyword" secondaryPlaceholder="Enter Your Delete Keyword" [addOnBlur]="true"
                            [clearOnBlur]="true" [modelAsStrings]="true" theme="minimal" id="deleteKeywords"
                            name="deleteKeywords" autocomplete="off" [disable]="disableInput" [addOnPaste]="true"
                            [pasteSplitPattern]="splitPattern" (onAdd)="onKeywordsAdded($event,'deleteKeywords')"></tag-input>
                        <span class="modalNote">Note: To add multiple keywords, please Press Enter Key after typing
                            each keyword</span>
                    </div>
                    <div class="form-group">
                        <label for="" class="form-label">Audit Comment</label>
                        <textarea formControlName="auditComments" type="text" class="form-control"
                            placeholder="Enter all audit comment"></textarea>

                            <span class="text-danger"
                            *ngIf="uploadForm.controls['auditComments'].value !=='' && uploadForm.hasError('pattern','auditComments')">
                            Enter subject not valid</span>
                    </div> -->
                    <div class="form-group">
                        <label for="" class="form-label">Language</label>
                        <ng-select formControlName="language" type='text' dropdownPosition="auto" [clearable]="false">
                            <ng-option *ngFor="let data of languageAudio" title="{{data.name}}"
                                [value]="data.code">{{data.name}}</ng-option>
                        </ng-select>
                    </div>
                    <div class="buttons text-end">
                        <button class="btn btn-light cancelBtn" type="button"
                            (click)="reDirectMainPage()">Cancel</button>
                        <button class="btn btn-primary updateBtn" type="button" (click)="onSubmit()"
                            [disabled]="!spinner && uploadForm.invalid || fileData.length === 0">
                            <div class="spinner-border spinner-border-sm" role="status" *ngIf="spinner">
                                <span class="visually-hidden">Loading...</span>
                            </div>
                            Upload
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
    <!-- delete modal -->
    <div class="modal fade deleteModal" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel"
        aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title" id="exampleModalLabel">Delete File</h4>
                    <i class="fa-solid fa-xmark exitIcon" data-bs-dismiss="modal" aria-label="Close"></i>
                </div>
                <div class="modal-body">
                    Are you sure you want to delete?
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">No</button>
                    <button type="button" class="btn btn-danger" (click)="deleteSelectFile(fileIndex)"
                        data-bs-dismiss="modal">Yes</button>
                </div>
            </div>
        </div>
    </div>
</div>